export default __webpack_public_path__ + "static/media/logo googleg 48dp.680de2e6.svg";